export default __webpack_public_path__ + "static/media/close.c0ba3c30.svg";